import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const FORGOT_PASSWORD_URL = "https://dimwpgeuqvtzlrlvveme.supabase.co/functions/v1/forgot-password";

export default function ForgotPasswordPage() {
  const { isAuthenticated } = useAuth();

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    setMessage("");

    if (!email.trim()) {
      setStatus("error");
      setMessage("Lütfen email adresinizi giriniz.");
      return;
    }

    try {
      const response = await fetch(FORGOT_PASSWORD_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string}`,
        },
        body: JSON.stringify({
          email: email.trim(),
          baseUrl: window.location.origin,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus("success");
        setMessage(data.message);
      } else {
        setStatus("error");
        setMessage(data.message || "Bir hata oluştu.");
      }
    } catch {
      setStatus("error");
      setMessage("Bağlantı hatası. Lütfen tekrar deneyin.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-key-2-line text-2xl text-background-50"></i>
            </div>
            <h1 className="text-2xl font-bold text-foreground-950 font-heading">Şifremi Unuttum</h1>
            <p className="text-foreground-600 mt-1 text-sm">Email adresinizi girin, şifre sıfırlama bağlantısı gönderelim.</p>
          </div>

          {status === "success" ? (
            <div className="text-center space-y-4">
              <div className="bg-accent-100 border border-accent-300 text-accent-900 rounded-lg px-4 py-3 text-sm">
                <i className="ri-checkbox-circle-line text-lg block mb-1"></i>
                {message}
              </div>
              <a
                href="/login"
                className="inline-block text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-1"></i>
                Giriş sayfasına dön
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Email Adresi
                </label>
                <div className="relative">
                  <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@email.com"
                    className="w-full pl-10 pr-4 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                    autoComplete="email"
                  />
                </div>
              </div>

              {status === "error" && (
                <div className="bg-accent-100 border border-accent-300 text-accent-900 rounded-lg px-4 py-2.5 text-sm flex items-center gap-2">
                  <i className="ri-error-warning-line text-base shrink-0"></i>
                  {message}
                </div>
              )}

              <button
                type="submit"
                disabled={status === "loading"}
                className="w-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium py-2.5 rounded-lg text-sm transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line"></i>
                    Sıfırlama Bağlantısı Gönder
                  </>
                )}
              </button>

              <div className="text-center">
                <a
                  href="/login"
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line mr-1"></i>
                  Giriş sayfasına dön
                </a>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}